import { IconProps } from './icons-props';

function MessageText({ className, width = 18, height = 18 }: IconProps) {
    return (
        <>
            <svg
                className={className}
                width={width}
                height={height}
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M12 17.0625H2.25C1.53 17.0625 0.9375 16.47 0.9375 15.75V6C0.9375 2.685 2.685 0.9375 6 0.9375H12C15.315 0.9375 17.0625 2.685 17.0625 6V12C17.0625 15.315 15.315 17.0625 12 17.0625ZM6 2.0625C3.315 2.0625 2.0625 3.315 2.0625 6V15.75C2.0625 15.855 2.145 15.9375 2.25 15.9375H12C14.685 15.9375 15.9375 14.685 15.9375 12V6C15.9375 3.315 14.685 2.0625 12 2.0625H6Z'
                    fill='currentColor'
                />
                <path
                    d='M12.75 7.6875H5.25C4.9425 7.6875 4.6875 7.4325 4.6875 7.125C4.6875 6.8175 4.9425 6.5625 5.25 6.5625H12.75C13.0575 6.5625 13.3125 6.8175 13.3125 7.125C13.3125 7.4325 13.0575 7.6875 12.75 7.6875Z'
                    fill='currentColor'
                />
                <path
                    d='M10.5 11.4375H5.25C4.9425 11.4375 4.6875 11.1825 4.6875 10.875C4.6875 10.5675 4.9425 10.3125 5.25 10.3125H10.5C10.8075 10.3125 11.0625 10.5675 11.0625 10.875C11.0625 11.1825 10.8075 11.4375 10.5 11.4375Z'
                    fill='currentColor'
                />
            </svg>
        </>
    );
}

export default MessageText;

